
import { IAppConfigState } from './app-config-types.store';

export class AppConfigState implements IAppConfigState {
	formDataConfigs: Object;
	systemAppConfigs: Object;
	userAppConfigs: Object;
    constructor() {
		this.formDataConfigs = {};
		this.systemAppConfigs = {};
		this.userAppConfigs = {};
    }
}

